module.exports = __webpack_public_path__ + "media/images/captive_portal/Marketing-c6f24492eb61f3cdb078bec1009fa008.svg";